// extracted by mini-css-extract-plugin
module.exports = {"labels":"e2ff468f85--labels--tSxl6","label":"e2ff468f85--label--JoNst"};